// extracted by mini-css-extract-plugin
module.exports = {"qrCodeContainer":"ScanStep_qrCodeContainer__4ovZd"};